import * as sitesActions from './actions';
import sitesReducer from './reducer';
import * as sitesTypes from './types';

export {sitesActions, sitesTypes};

export default sitesReducer;
